import { Controller } from 'stimulus';
import concord from 'concord';

class ConcordController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    concord({
      offset: window.outerHeight * -0.2,
    });
  }
}

ConcordController.targets = [
  //
];

export default ConcordController;
